var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointSystemLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "point_bg",
    d: "M18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18C2 9.16344 9.16344 2 18 2ZM12 27H16.1084V21.0557H18.6328C22.695 21.0557 25.9998 19.1071 26 14.8721C26 10.4683 22.7869 9.00001 18.4951 9H12V27ZM18.2881 12.3926C20.6061 12.3926 22.0068 13.0191 22.0068 14.8721C22.0067 16.7007 20.79 17.6631 18.4033 17.6631H16.1084V12.3926H18.2881Z",
    fill: "#FFCE00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointSystemLogo);
export default __webpack_public_path__ + "static/media/point_system_logo.f138d03edfa90a4dfbb86ab053276417.svg";
export { ForwardRef as ReactComponent };